import { render, staticRenderFns } from "./NoCreditMessage.vue?vue&type=template&id=7489fa60&scoped=true&"
import script from "./NoCreditMessage.vue?vue&type=script&lang=js&"
export * from "./NoCreditMessage.vue?vue&type=script&lang=js&"
import style0 from "./NoCreditMessage.vue?vue&type=style&index=0&id=7489fa60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7489fa60",
  null
  
)

export default component.exports